import React from "react";
import ReactHtmlParser from "react-html-parser";
import PropTypes from "prop-types";

class HtmlComponent extends React.Component {
  static propTypes = {
    mdFile: PropTypes.string,
  };

  render() {
    // const html = '<div>Example HTML string</div>';
    return <div>{ReactHtmlParser(this.props.mdFile)}</div>;
  }
}

export default HtmlComponent;
